{
  "salon-search-result-page": {
    "buttons": {
      "book-appointment": "REZERVOVAT SCHŮZKU",
      "explore": "EXPLORE",
      "show-more": "ZOBRAZIT VÍCE"
    },
    "text": {
      "salon-around": "Salony v okolí"
    }
  }
}
